//libs
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router';

//actions
import { ActionTypes } from 'shared/store/listingV2/actions';

//helpers
import { getAppliedFiltersString, getParamsObject, getURLQuery, makeUrlParams } from 'shared/store/listingV2/helpers';

var lastAppliedFilter: string | number | boolean = '';
export const useFetchPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const params = getParamsObject(location.search);

  const fetchPage = useCallback(() => {
    const pageNumber = Number(params.p) || 1;
    const urlParams = makeUrlParams(params, { p: pageNumber + 1 });
    history.replace(`${location.pathname}?${urlParams}`);
    dispatch({ type: ActionTypes.UPDATE_PAGE_NUMBER, payload: pageNumber + 1 });
  }, [dispatch, history, location.pathname, params]);

  return { fetchPage };
};

export const useFilters = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const params = getParamsObject(location.search);
  const updateAppliedFilter = (appliedFilters: Record<string, string>) => {
    const urlParams = makeUrlParams(params, { f: getAppliedFiltersString(appliedFilters), p: '' });
    history.push(`${location.pathname}?${urlParams}`);
    dispatch({
      type: ActionTypes.UPDATE_APPLIED_FILTERS,
      payload: appliedFilters,
    });
  };

  useEffect(() => {
    const newFilters = getURLQuery(location.search, location.pathname);
    if (lastAppliedFilter !== newFilters?.f) {
      lastAppliedFilter = newFilters?.f;
      dispatch({
        type: ActionTypes.UPDATE_APPLIED_FILTERS,
        payload: newFilters,
      });
    }
  }, [dispatch, location.search, location.pathname]);
  return { updateAppliedFilter };
};
